import Vue from 'vue'
import Vuex from 'vuex'

import wahrhouseModule from './modules/warhouses.js';

Vue.use(Vuex)

export default new Vuex.Store({
  
    state() {
        return {
            open: false,
            openNotif: false,
            loading:false,
            loadingEmail:'pending',
            update:false,
            update_version:1,
            model:'',
            pr_version:1,
            NewNotifs:0,
            OldNotifs:0,
            sous_warehouses:[],
            user:{},
            settings:[],
            settingsGlobal:{},
            currencySettings:'MAD',
            missedCalls:[]
        };
    },
    mutations: {
        actionSidebar(state) {
            state.open = !state.open;
        },
        actionloadingpage: function(state, payload) {
            state.loading = payload.loading;
        },
        actionloadingemail: function(state, payload) {
            state.loadingEmail = payload.loadingEmail;
        },
        actionupdate: function(state, payload) {
            console.log('old state-------',state)
            state.update = payload.update;
           if(payload.update_version) state.update_version += 1;
           if(payload.pr_version) state.pr_version = payload.pr_version;
           state.NewNotifs = payload.NewNotifs;
           state.OldNotifs = payload.OldNotifs;
           console.log('new state-------',state)
        },
        modelupdate: function(state, payload) {
            state.model = payload.model;
        },
        actionSousWarehouses: function(state, payload) {
            state.sous_warehouses = payload.sous_warehouses;
        },
        actionSeller: function(state, payload) {
            state.user = payload.user;
            if(payload.settings) state.settings = payload.settings;
            if(payload.settingsGlobal) state.settingsGlobal = payload.settingsGlobal;
        },
        actionNotif: function(state, payload) {
            state.openNotif = payload.openNotif;
        },
        // ── Missed-call callback queue ──
        SET_MISSED_CALLS(state, list) {
            // MERGE (not overwrite) so a live socket item that arrived while the initial
            // poll was in flight isn't dropped by the older server snapshot.
            const snap = Array.isArray(list) ? list : [];
            const seen = new Set(snap.map((m) => String(m._id)));
            const localOnly = (state.missedCalls || []).filter((m) => !seen.has(String(m._id)));
            state.missedCalls = [...snap, ...localOnly];
        },
        // Authoritative refresh (periodic poll): items no longer waiting are DROPPED.
        REPLACE_MISSED_CALLS(state, list) {
            state.missedCalls = Array.isArray(list) ? list : [];
        },
        ADD_MISSED_CALL(state, mc) {
            if (!mc || !mc._id) return;
            if (state.missedCalls.some((m) => String(m._id) === String(mc._id))) return;
            state.missedCalls.unshift(mc);
        },
        REMOVE_MISSED_CALL(state, id) {
            if (!id) return;
            state.missedCalls = state.missedCalls.filter((m) => String(m._id) !== String(id));
        },
    },
    actions: {
        actionSidebar(context) {
            context.commit('actionSidebar');
        },
        actionloadingpage(context, payload) {
            context.commit('actionloadingpage',payload);
        },
        actionloadingemail(context, payload) {
            context.commit('actionloadingemail',payload);
        },
        actionupdate(context, payload) {
           // console.log('payload  actions------',payload)
            context.commit('actionupdate',payload);
        },
        modelupdate(context, payload) {
            console.log('payload  modelupdate------',payload)
            context.commit('modelupdate',payload);
        },
        actionSousWarehouses(context, payload) {
            context.commit('actionSousWarehouses',payload);
        },
        actionSeller(context, payload) {
            context.commit('actionSeller',payload);
        },
        actionNotif(context, payload) {
            context.commit('actionNotif',payload);
        },
    },
    getters: {
        ShowSidebar(state) {
            return state.open;
        },
        loadingpage(state) {
            return state.loading;
        },
        loadingemail(state) {
            return state.loadingEmail;
        },
        checkUpdate(state) {
            return state.update;
        },
        resize() {
            if (window.innerWidth < 960) return true
            else return false
        },
    },
    modules:{
        wharhouse: wahrhouseModule,
    }

})
